module.exports = __webpack_public_path__ + "img/cross.e6c4fd85.svg";